import React, { useState } from "react";
import fundacionNicanImg from "../imgs/formulario/fundacion-nican.png";
import { Form, Button } from "react-bootstrap";
import Swal from "sweetalert2";
import { trackLeadFormSubmit, trackWhatsAppClick } from "../utils/analytics";
import "../styles/ContactForm.css";

const whatsappNumber = "5579118589";

function ContactForm() {
  const [formData, setFormData] = useState({
    nombre: "",
    curso: "",
    mensaje: "",
  });

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    Swal.fire({
      title: "Abriremos WhatsApp",
      text: "Enviaremos un mensaje sin compromiso para ofrecerte información y revisar opciones de descuento.",
      icon: "info",
      confirmButtonText: "Aceptar",
      confirmButtonColor: "var(--primary-color)",
    }).then((result) => {
      if (result.isConfirmed) {
        trackLeadFormSubmit(formData.curso);
        trackWhatsAppClick("formulario_contacto", {
          course_interest: formData.curso || "sin_especificar",
        });
        const message = `Hola, soy ${formData.nombre} y estoy interesado/a en el curso ${formData.curso}.
Me gustaría certificarme porque: ${formData.mensaje}.
¿Podrían proporcionarme más información, por favor?`;
        window.open(
          `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`,
          "_blank",
          "noopener,noreferrer"
        );
      }
    });
  };

  return (
    <section id="contact" className="contact-form-section my-5" data-aos="fade-right">
      <div className="container">
        <div className="contact-form-header">
          <h2>Solicita información sobre nuestros cursos</h2>
          <p>
            Déjanos tus datos básicos y te orientamos por WhatsApp sobre el
            programa que mejor se adapte a tus objetivos.
          </p>
        </div>

        <div className="contact-form-shell">
          <div className="contact-form-image">
            <img
              src={fundacionNicanImg}
              alt="Fundación Nican"
              className="img-fluid"
            />
          </div>

          <div className="contact-form-card">
            <Form onSubmit={handleSubmit}>
              <Form.Group controlId="nombre" className="mb-3">
                <Form.Label>Nombre</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Tu nombre"
                  value={formData.nombre}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
              <Form.Group controlId="curso" className="mb-3">
                <Form.Label>Curso de interés</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Ej. Auxiliar de enfermería"
                  value={formData.curso}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
              <Form.Group controlId="mensaje" className="mb-4">
                <Form.Label>¿Qué quieres lograr?</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  placeholder="Cuéntanos brevemente tu objetivo"
                  value={formData.mensaje}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
              <Button variant="primary" type="submit" className="contact-submit">
                Pedir información por WhatsApp
              </Button>
            </Form>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ContactForm;
